import Button from '~/src/common/components/Button';
import I18n from '~/src/common/services/I18n';

import * as S from './layout';

type Props = {
  term: string;
  isLoading: boolean;
  onRetryClick: () => void;
};

const Error = ({ term, onRetryClick, isLoading }: Props) => (
  <S.Container>
    <S.Image />
    <S.Content>
      {I18n.t('search.results.status.error.line1')}
      <S.Term>{term}</S.Term>
      <S.Dot>. </S.Dot>
      {I18n.t('search.results.status.error.line2')}
    </S.Content>
    <Button onClick={onRetryClick} disabled={isLoading}>
      {isLoading ? <S.Loader color="WHITE" /> : I18n.t('search.results.status.error.retry')}
    </Button>
  </S.Container>
);

export default Error;
